module.exports = __webpack_public_path__ + "img/icone-arquivo.76858e7a.svg";